exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__wrapper___XfxmV{display:block;margin-right:1em;position:absolute;max-width:170px;bottom:-99px}@media (max-width:1024px){.index-module__wrapper___XfxmV{right:0}}@media (min-width:1024px){.index-module__wrapper___XfxmV{left:2em}}", ""]);

// exports
exports.locals = {
	"wrapper": "index-module__wrapper___XfxmV"
};